var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"p-color-primary",attrs:{"ripple":false,"outlined":"","small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }